export default __webpack_public_path__ + "static/material_03-0aa0bb24be23d3b73a38a84ab42568f4.png";